export function createTypingReporter(send, keepAliveMilliseconds = 2000) {
  let active = false;
  let disposed = false;
  let timer = null;

  const transmit = value => Promise.resolve(send(value)).catch(() => null);
  const stopTimer = () => {
    clearInterval(timer);
    timer = null;
  };

  const update = nextActive => {
    if (disposed) return;
    const shouldBeActive = Boolean(nextActive);
    if (!shouldBeActive) {
      if (active) void transmit(false);
      active = false;
      stopTimer();

      return;
    }

    if (active) return;
    active = true;
    void transmit(true);
    stopTimer();
    timer = setInterval(() => {
      if (active && !disposed) void transmit(true);
    }, keepAliveMilliseconds);
  };

  const stop = () => update(false);
  const dispose = () => {
    stop();
    disposed = true;
    stopTimer();
  };

  return {update, stop, dispose};
}

export function createTypingExpiry(onChange, fallbackMilliseconds = 6500) {
  let timer = null;

  const clear = () => {
    clearTimeout(timer);
    timer = null;
    onChange(false);
  };

  const receive = payload => {
    clearTimeout(timer);
    timer = null;
    if (!payload?.active) {
      onChange(false);

      return;
    }

    onChange(true);
    const expiresAt = Date.parse(payload.expires_at || '');
    const delay = Number.isFinite(expiresAt)
      ? Math.max(100, expiresAt - Date.now() + 100)
      : fallbackMilliseconds;
    timer = setTimeout(clear, delay);
  };

  const dispose = () => clear();

  return {receive, clear, dispose};
}
